<template>
  <div>
    <b-container fluid class="d-flex align-items-center back-wrapper">
          <b-row >
            <b-col lg="7" md="10">
              <router-link :to="{name: 'modelos'}" class="back-item">
                  <img class="arrow-back" src="img/theme/icn_arrowback.svg" alt="">
                  <span>Modelos</span>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">Editar color</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> La información del color se actualizó exitosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">Información del color</h6>


              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nombre del color"
                      placeholder="Nombre"
                      v-model="nameColor"
                      name="Nombre"
                      required
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Valor hexadecimal"
                      placeholder="Ejemplo #000"
                      v-model="hexColor"
                      name="Valor"
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4">
              <b-button type="submit" variant="primary" class="mt-4">Guardar</b-button>
              <b-button :to="{ name: 'modelos'}" variant="danger" class="mt-4">Cancelar</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      nameColor: '',
      hexColor: '',
      success: '',
      error: '',
      brand: '',
      gender: '',
      optionsModels: []
    }
  },
  methods: {
    updateProfile() {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({
          api_token: this.token,
          user_id: this.user,
          option: 'edit_color',
          c_id: this.$route.params.colorsId,
          c_name: this.nameColor,
          c_hex: this.hexColor
        }),
      )
      .then((response) => {
        if (!response.data.error.code) {
          this.success = true
        } else {
          this.success = false
          this.error = response.data.error.description
        }
      })
      .catch((err) => {
        console.log(err)
      })
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    this.user = localStorage.getItem('id_user')
    axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
      qs.stringify({
        api_token: this.token,
        user_id: this.user,
        option: 'get_color',
        c_id: this.$route.params.colorsId
      }),
    )
    .then((response) => {
      if (!response.data.error.code) {
        this.nameColor = response.data.color.name
        this.hexColor = response.data.color.hex
        }
    })
    .catch((err) => {
      console.log(err)
    })
  }
};
</script>
<style></style>
